import { Injectable, InjectionToken } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ForecastManagerService {
  customForecastChange: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  saveCustomForecast(reportId: number) {
    this.customForecastChange.next(reportId);
  }
}
